import Vue from "vue";
import Router from "vue-router";
import store from "../store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: { name: "Login" }
    },
    {
      path: "/connexion",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
      meta: {
        guest: true,
        layout: () =>
          import(/* webpackChunkName: "layouts.portal" */ "@/layouts/Portal.vue")
      }
    },
    {
      path: "/reinitialisation",
      name: "Reset",
      component: () =>
        import(/* webpackChunkName: "reset" */ "@/views/Reset.vue"),
      meta: {
        guest: true,
        layout: () =>
          import(/* webpackChunkName: "layouts.portal" */ "@/layouts/Portal.vue")
      }
    },
    {
      path: "/portail",
      name: "Portal",
      component: () =>
        import(/* webpackChunkName: "portal" */ "@/views/Portal.vue"),
      meta: {
        guest: false,
        layout: () =>
          import(/* webpackChunkName: "layouts.portal" */ "@/layouts/Portal.vue")
      }
    },
    {
      path: "/verify",
      name: "Verify",
      component: () =>
        import(/* webpackChunkName: "verify" */ "@/views/Verify.vue"),
      beforeEnter: (to, from, next) => {
        if (
          JSON.parse(process.env.VUE_APP_ALLOWED_DOMAIN).filter(el => {
            return document.referrer.indexOf(el) === 0;
          }).length === 0
        ) {
          return;
        }
        next();
      },
      meta: {
        guest: true,
        layout: () =>
          import(/* webpackChunkName: "layouts.portal" */ "@/layouts/Portal.vue")
      }
    },
    {
      path: "*",
      component: () =>
        import(/* webpackChunkName: "not.found" */ "@/views/NotFound.vue")
    }
  ],
  linkActiveClass: "is-active",
  linkExactActiveClass: "exact-active"
});

async function isAuthenticated() {
  return store.dispatch("auth/verifyRoutes");
}

router.beforeEach(async (to, from, next) => {
  // This route is marked as guest, you can access if you are not authenticated :
  if (to.matched.some(record => record.meta.guest)) {
    if (to.name !== "Verify" && (await isAuthenticated())) {
      next({ name: "Portal" });
    } else {
      next();
    }
  } else {
    if (await isAuthenticated()) {
      next();
    } else {
      next({ name: "Login" });
    }
  }
});

export default router;
